import React from 'react';
import HtmlDecode from '../../../../../../../utils/htmlDecode';
import { useSelector } from 'react-redux';

const Controls = props => {
  const {
    name,
    title,
    handleNextSlide,
    handlePrevSlide,
    showControls,
    stylesHeader = {},
    stylesNavigation = {},
  } = props;
  const asset = useSelector(state => state.asset);
  const { search_overCarousel_home_icon_surf } = asset;

  return (
    <div className="carousel-button-group">
      <div className="contents-carousel__header" style={{ ...stylesHeader }}>
        <h2 className="contents-carousel__header__title">
          {HtmlDecode(title)}
        </h2>
        {showControls && (
          <div
            className={`contents-carousel__header__navigation`}
            style={{ ...stylesNavigation }}
          >
            <img
              alt="prev button"
              className={`contents-carousel__header__navigation__prev-btn prev-${name}`}
              src={search_overCarousel_home_icon_surf}
              onClick={() => handlePrevSlide()}
            />

            <img
              className={`contents-carousel__header__navigation__next-btn next-${name}`}
              alt="next button"
              src={search_overCarousel_home_icon_surf}
              onClick={() => handleNextSlide()}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Controls;
